/**
 * Compare two addresses for equality (byte-by-byte)
 *
 * @param {import('../Address/AddressType.js').AddressType} a
 * @param {import('../Address/AddressType.js').AddressType} b
 * @returns {boolean}
 */
function addressEquals(a, b) {
	if (a.length !== b.length) return false;
	for (let i = 0; i < a.length; i++) {
		if (a[i] !== b[i]) return false;
	}
	return true;
}

/**
 * Compare two hashes for equality (byte-by-byte)
 *
 * @param {import('../Hash/HashType.js').HashType} a
 * @param {import('../Hash/HashType.js').HashType} b
 * @returns {boolean}
 */
function hashEquals(a, b) {
	if (a.length !== b.length) return false;
	for (let i = 0; i < a.length; i++) {
		if (a[i] !== b[i]) return false;
	}
	return true;
}

/**
 * Check if storage key is in access list for given address (EIP-2930)
 *
 * @param {import('../BrandedAccessList.js').BrandedAccessList} list - Access list to search
 * @param {import('../Address/AddressType.js').AddressType} address - Address to check
 * @param {import('../Hash/HashType.js').HashType} storageKey - Storage key to find
 * @returns {boolean} true if storage key is accessible
 *
 * @example
 * ```typescript
 * const list = AccessList([{ address, storageKeys: [key] }]);
 * const isAccessible = AccessList.includesStorageKey(list, address, key); // Static call
 * const isAccessible2 = list.includesStorageKey(address, key); // Instance call
 * ```
 */
export function includesStorageKey(list, address, storageKey) {
	for (const item of list) {
		if (addressEquals(item.address, address)) {
			for (const key of item.storageKeys) {
				if (hashEquals(key, storageKey)) {
					return true;
				}
			}
		}
	}
	return false;
}
